import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { MonitorSuggestApi, MonitorRecommendApiResponse } from '../monitor-suggest-api';
import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';

@injectable()
export class MonitorSuggestApiImpl extends PsHttpService implements MonitorSuggestApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka`,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    getMonitorRecommendList() {
        return this.get<PatSnapCommonResponseData<MonitorRecommendApiResponse>>({
            url: '/news-letter/recommend',
        }).then((res) => {
            return res.data as MonitorRecommendApiResponse;
        });
    }
}
